import { useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "../../shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  InputType,
  RowVisibility,
  SelectFilter,
} from "../../shared/filters/types/filter";
import { StoreTeam } from "@coworker/types/lib/storeteam";

export function useAssigneeOrCreatorFilter(
  id: "assignedTo" | "createdBy",
  uid: string,
  transKey: string,
  teams: StoreTeam[]
): SelectFilter {
  const { t } = useTranslation();
  const defaultValue = { filterId: id, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: id,
      title: t(transKey),
      options: [
        {
          value: uid,
          title: t("meString"),
        },
        ...teams.map((team) => ({
          value: team.id,
          title: team.name,
        })),
      ],
      enabled: true,
      defaultValue,
      rowVisibility: RowVisibility.Hidden,
    },
    t("allString")
  );
}
